module.exports = __webpack_public_path__ + "img/cabinet.aaeb7e39.png";